import i18n from './index';
import { NAV_LABEL_KEYS } from './bindCopy';

/** 英文兜底：词条没命中时不要退回中文菜单。 */
const EN = {
  publish: 'Publish',
  productInfo: 'Product info',
  records: 'Publish history',
  drafts: 'Drafts',
  productTemplate: 'Product templates',
  sizeChart: 'Size charts',
  attributes: 'Attributes',
  brands: 'Brands',
  shipWarehouse: 'Warehouses',
  freight: 'Shipping templates',
  model: 'Models',
  photoLib: 'Real photos',
  certificates: 'Certificates',
  rrpLibrary: 'Suggested prices',
  materials: 'Compliance files',
  packing: 'Packaging compliance',
  ads: 'Product ads',
  sampleQc: 'Sample QC',
  orderList: 'Orders',
  returns: 'Returns',
  cancellations: 'Cancellations',
  businessData: 'Business data',
  activities: 'Campaigns',
  enrollProducts: 'Campaign products',
  coupons: 'Coupons',
  home: 'Home',
  products: 'Products',
  productCompliance: 'Product compliance',
  templates: 'Templates',
  marketing: 'Marketing',
  orders: 'Orders',
  analytics: 'Analytics',
  finance: 'Finance',
  shopInfo: 'Shop info',
  stock: 'Warehouse stock',
  discussOffline: 'Merchant price change (retired)',
  priceOffline: 'Price (retired)',
  orderManage: 'Order management',
  fulfillment: 'Fulfillment',
  warehouseTemplate: 'Warehouse templates',
  complianceInfo: 'Compliance info',
  realPhotos: 'Real photos',
  certQual: 'Certificate qualifications',
  priceReview: 'Price reviews',
  priceAdjust: 'Price adjustments',
  stocking: 'Stock and ship',
  printCenter: 'Print center',
  salesVolume: 'Sales data',
  enrollRecords: 'Enrollments',
  priceHandle: 'Price handling',
  complianceQual: 'Compliance',
  price: 'Price',
  discussOrders: 'Bargains',
  suggestedRetail: 'Suggested retail price',
};

function rawLabel(item) {
  if (typeof item?.labelFallback === 'string' && item.labelFallback) return item.labelFallback;
  const desc = item ? Object.getOwnPropertyDescriptor(item, 'label') : null;
  if (desc && 'value' in desc && typeof desc.value === 'string') return desc.value;
  return '';
}

/** 侧栏文案走 workbench.platformNav。三个平台共用。 */
export function platformNavLabel(t, item) {
  const shown = item?.label;
  const raw = rawLabel(item) || (typeof shown === 'string' ? shown : '');
  const key = item?.labelKey || NAV_LABEL_KEYS[raw] || NAV_LABEL_KEYS[shown];
  if (!key) return shown;
  const lang = String(i18n.resolvedLanguage || i18n.language || '');
  if (lang.toLowerCase().startsWith('zh')) return raw || shown;
  const viaT = typeof t === 'function' ? t(`platformNav.${key}`, { defaultValue: '' }) : '';
  if (viaT && viaT !== raw && viaT !== `platformNav.${key}`) return viaT;
  return EN[key] || viaT || shown;
}
